<template>
  <component
    :is="compType"
    :class="[
      {
        'text-2xl font-bold': theme === 'h1',
        'text-xl font-semibold': theme === 'h2',
        'text-xl font-light ': theme === 'h3',
        'text-md font-light ': theme === 'h5',
        'font-bold': theme === 'h4',
      },

      `text-${position}`,
    ]"
  >
    <slot></slot>
  </component>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import type { MHeadingProps } from '.';

  const props = withDefaults(defineProps<MHeadingProps>(), {
    theme: 'default',
    position: 'start',
  });

  const compType = computed(() => {
    if (props.theme === 'default') return 'h3';
    return props.theme;
  });
</script>
